export default __webpack_public_path__ + "f36ee69fcf6b55111dd3eadb830f49cd.svg";